import { render, staticRenderFns } from "./box_goods_edit.vue?vue&type=template&id=3e6ceeb6"
import script from "./box_goods_edit.vue?vue&type=script&lang=js"
export * from "./box_goods_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports